import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

export type SoundState = 'on' | 'off';

@Injectable({
  providedIn: 'root',
})
export class SoundService {
  private _sound: WritableSignal<SoundState> = signal<SoundState>('on');
  public readonly sound: Signal<SoundState> = this._sound.asReadonly();

  setSound(sound: SoundState): void {
    this._sound.set(sound);
  }

  initFromQueryParam(soundParam: string | null): void {
    if (soundParam === 'on' || soundParam === 'off') {
      this.setSound(soundParam);
    }
  }
}
